<template>
  <el-table-column
    prop="status"
    label="Review"
    width="80"
    header-align="center"
    align="center"
  >
    <template #default="scope">
      <div
        v-if="scope.row.status === 'reviewed'"
        class="review-number-container large-font-column cursor-pointer border-2 !border-yellow-700 rounded px-2 py-1 hover:bg-blue-500 transition-all duration-300 relative z-10"
        @click="handleReviewUnset(scope.row)"
      >
        {{ scope.row.rating }}
      </div>
      <div v-else class="text-center"></div>
    </template>
  </el-table-column>
</template>

<script setup>
import api from "@/composables/api";
import { useReviewers, useDump } from "@/stores";

const reviewersStore = useReviewers();
const dumpStore = useDump();

const props = defineProps({
  onPinGrab: {
    type: Function,
    required: true,
  },
});

const handleReviewUnset = async (reviewer) => {
  const reviewConfirmed = window.confirm(
    `Click OK to reset the review for ${reviewer.email}. This will make the link ask for a review again.`
  );

  if (!reviewConfirmed) {
    return;
  }
  const hashId = reviewer.emailHash.split("/").pop();
  await api(`v1/reviewer/unsetreview/${hashId}`);
  dumpStore.handleTableRefresh();
  props.onPinGrab();
};
</script>

<style scoped>
.large-font-column {
  font-size: 24px;
}

.review-number-container {
  display: inline-block;
  min-width: 40px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
